<template>
  <div>
    <form method="post" @submit.prevent="updateReport">
      <!-- <div class="container table-actions">
        <div>
          Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }} Статус: {{ REPORT.status }}
        </div>
        <button class="table-actions-button btn-green" type="submit">
          Сохранить
        </button>
      </div> -->

      <div class="table-title">
        Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }}
      </div>
      <div class="categories-top-actions">
        <button class="table-actions-button btn-green" type="submit">
          Сохранить
        </button>
      </div>

      <div class="table-container-inner">
        <table>
          <thead>
            <tr>
              <td class="table-specs" colspan="2" rowspan="2">
                Характеристики
              </td>
            </tr>
            <tr class="tr-fixed-height">
              <th
                class="metall-measure-unit"
                rowspan="2"
                colspan="1"
                scope="colgroup"
              >
                Единица измерения
              </th>
              <!-- Hide Remnant -->
              <th
                class="metall-slot-hidden"
                colspan="3"
                scope="colgroup"
                rowspan="2"
                style="border-top: 1px solid #868686; margin-top: -10px"
              >
                <button
                  type="button"
                  class="show-btn"
                  @click="showRemnantColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                <p>Показать</p>
                <span>остаток</span>
              </th>
              <th
                class="metall-left-in-stock-botm"
                colspan="3"
                scope="colgroup"
              >
                Остаток металлолома на складе на начало месяца
              </th>
              <th class="metall-received" colspan="1" scope="colgroup">
                <button
                  type="button"
                  class="hide-btn"
                  @click="hideRemnantColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                Поступление
              </th>
              <th class="metall-received" colspan="1" scope="colgroup">
                Реализация на собственные нужды
              </th>
              <th class="metall-received" colspan="1" scope="colgroup">
                Социальное обязательство
              </th>
              <th
                class="metall-slot-hidden-contract"
                colspan="1"
                rowspan="1"
                style="border-top: 1px solid #868686; margin-top: -10px"
              >
                <button
                  type="button"
                  class="show-btn"
                  @click="showContractColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                <p>Показать информацию о контракте</p>
              </th>
              <th
                class="metall-information metall-info-contract-cell"
                colspan="11"
                scope="colgroup"
              >
                <button
                  type="button"
                  class="hide-btn"
                  @click="hideContractColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                Информация по заключенным договорам
              </th>
              <th
                class="metall-left-in-stock-eotm metall-info-notes-cell"
                colspan="2"
                scope="colgroup"
              >
                Остаток металлолома на складе на конец месяца
              </th>
              <th
                class="metall-slot-hidden-notes"
                rowspan="2"
                colspan="1"
                style="
                  border-top: 1px solid #868686;
                  border-right: 1px solid #868686;
                  margin-top: -10px;
                "
              >
                <button
                  type="button"
                  class="show-btn"
                  @click="showNotesColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                <p>Показать</p>
                <span>остаток</span>
              </th>
              <th class="metall-notes metall-info-notes-cell" rowspan="2">
                <button
                  type="button"
                  class="hide-btn"
                  @click="hideNotesColumns"
                >
                  <i class="fas fa-arrows-alt-h"></i>
                </button>
                Примечание
              </th>
            </tr>
            <tr>
              <th scope="col" style="background: #36429e; border: none"></th>
              <th scope="col" style="background: #36429e; border: none"></th>
              <th class="metall-slot-hidden" scope="col">...</th>
              <th class="metall-left-in-stock-sub-botm expanded" scope="col">
                Кол-во
              </th>
              <th class="metall-left-in-stock-sub-botm" scope="col">
                Стоимость оценки
              </th>
              <th class="metall-left-in-stock-sub-botm expanded" scope="col">
                Сумма
              </th>
              <th class="metall-received-count" scope="col">Количество</th>
              <th class="metall-slot-hidden-contract" scope="col">...</th>
              <th class="metall-received-count" scope="col">Количество</th>
              <th class="metall-received-count" scope="col">Количество</th>
              <th
                class="metall-info-sub-count metall-info-contract-cell"
                scope="col"
              >
                Общее кол-во по договору
              </th>
              <th
                class="metall-info-sub-realization metall-info-contract-cell"
                scope="col"
              >
                Способ реализации
              </th>
              <th
                class="metall-info-sub-payment metall-info-contract-cell"
                scope="col"
              >
                Условия оплаты
              </th>
              <th
                class="metall-info-sub-naming metall-info-contract-cell"
                scope="col"
              >
                Наименование покупателя
              </th>
              <th
                class="metall-info-sub-bin metall-info-contract-cell"
                scope="col"
              >
                БИН
              </th>
              <th
                class="
                  metall-info-sub-contract-number metall-info-contract-cell
                "
                scope="col"
              >
                Номер договора
              </th>
              <th
                class="metall-info-sub-date metall-info-contract-cell"
                scope="col"
              >
                Дата договора
              </th>
              <th
                class="metall-info-sub-price metall-info-contract-cell expanded"
                scope="col"
              >
                Цена за ед. тенге
              </th>
              <th
                class="metall-info-sub-sum metall-info-contract-cell"
                scope="col"
              >
                Сумма договора, тенге
              </th>
              <th
                class="metall-info-sub-exported metall-info-contract-cell"
                scope="col"
              >
                Вывезенное количество
              </th>
              <th
                class="metall-info-sub-left metall-info-contract-cell"
                scope="col"
              >
                Остаток по договору
              </th>
              <th
                class="
                  metall-left-in-stock-sub-eotm metall-info-notes-cell
                  expanded
                "
                scope="col"
              >
                Кол-во
              </th>
              <th
                class="
                  metall-left-in-stock-sub-eotm metall-info-notes-cell
                  expanded
                "
                scope="col"
              >
                Сумма
              </th>
              <th
                class="metall-slot-hidden-notes"
                style="border-right: 1px solid #868686"
              >
                ...
              </th>
              <th style="border: none"></th>
            </tr>
          </thead>
          <tbody
            v-for="(request, request_index) in this.requests"
            :key="request_index"
          >
            <tr
              v-for="(contract, index) in request.contracts"
              :key="contract.id"
            >
              <th
                class="t-metall-sub-type"
                scope="rowgroup"
                v-if="request.is_color"
              >
                Цветной металл
              </th>
              <th class="t-metall-sub-type" scope="rowgroup" v-else>
                Черный металл
              </th>
              <th class="t-metall-sub-type" scope="row">
                {{ request.category }}
              </th>
              <!-- <td class="metall-slot-hidden">...</td> -->
              <td>T</td>
              <td class="metall-slot-hidden">...</td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="'metall-table-input ' + setColor(index)"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="
                    isDisabledForMain(index, request_index) ||
                    (isDisabled(index) && !contract.first)
                  "
                  v-model="request.count_before"
                  @change="
                    autoCalculateAfterCount(request_index) ||
                      autoCalculateBeforeSum(request_index)
                  "
                />
              </td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="'metall-table-input ' + setColor(index)"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.price_before"
                  @change="
                    autoCalculateAfterSum(request_index) ||
                      autoCalculateBeforeSum(request_index)
                  "
                />
              </td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="
                    'metall-table-input total_calculate ' + setColor(index)
                  "
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.total_before"
                  readonly
                  @change="autoCalculateBeforeSum(request_index)"
                />
              </td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="'metall-table-input ' + setColor(index)"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.count_come"
                  @change="
                    autoCalculateAfterCount(request_index) ||
                      autoCalculateAfterSum(request_index)
                  "
                />
              </td>
              <td class="metall-slot-hidden-contract">...</td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="'metall-table-input ' + setColor(index)"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.for_own_needs"
                  @change="
                    autoCalculateAfterCount(request_index) ||
                      autoCalculateAfterSum(request_index)
                  "
                />
              </td>
              <td class="metall-td-hide">
                <input
                  required
                  :class="'metall-table-input ' + setColor(index)"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.for_social_commitment"
                  @change="
                    autoCalculateAfterCount(request_index) ||
                      autoCalculateAfterSum(request_index)
                  "
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  class="metall-table-input contr_count"
                  type="number"
                  min="0"
                  step="0.01"
                  :readonly="!contract.first"
                  :id="index"
                  v-model="contract.contr_count"
                  @change="
                    change_contr_count(request_index, index) ||
                      autoCalculateContrTotal(request_index, index) ||
                      autoCalculateCountBalance(request_index, index) ||
                      autoCalculateAfterCount(request_index) ||
                      autoCalculateAfterSum(request_index) ||
                      deleteRequiredSelect(request_index, index)
                  "
                />
              </td>
              <td class="metall-info-contract-cell">
                <select
                  :id="'edit_select_contr_method_' + index"
                  :class="
                    'report-table-s selects_' + request_index + '_' + index
                  "
                  :disabled="!contract.first"
                  v-model="contract.contr_method"
                >
                  <option value="">Выберите значение</option>
                  <option value="Аукцион">Аукцион</option>
                  <option value="Товарная биржа">Товарная биржа</option>
                  <option value="Прямая адресная продажа">
                    Прямая адресная продажа
                  </option>
                </select>
              </td>
              <td class="metall-info-contract-cell">
                <select
                  :id="'edit_select_contr_conditions_' + index"
                  :class="
                    'report-table-s selects_' + request_index + '_' + index
                  "
                  :disabled="!contract.first"
                  v-model="contract.contr_conditions"
                >
                  <option value="">Выберите значение</option>
                  <option value="100% предоплата">100% предоплата</option>
                  <option value="30% предоплата">30% предоплата</option>
                </select>
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :id="'edit_contr_impl_' + index"
                  :readonly="!contract.first"
                  :class="
                    'metall-table-input selects_' + request_index + '_' + index
                  "
                  type="text"
                  v-model="contract.contr_impl"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :id="'edit_bin_company_' + index"
                  :readonly="!contract.first"
                  :class="
                    'bin-input-edit metall-table-input selects_' +
                    request_index +
                    '_' +
                    index
                  "
                  type="text"
                  min="0"
                  maxlength="14"
                  v-model="contract.bin_company"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :id="'edit_contr_number_' + index"
                  :readonly="!contract.first"
                  :class="
                    'metall-table-input selects_' + request_index + '_' + index
                  "
                  type="text"
                  v-model="contract.contr_number"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :id="'edit_contr_date_' + index"
                  :readonly="!contract.first"
                  :class="
                    'metall-table-input selects_' + request_index + '_' + index
                  "
                  type="date"
                  v-model="contract.contr_date"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :readonly="!contract.first"
                  :class="
                    'metall-table-input selects_' + request_index + '_' + index
                  "
                  type="number"
                  :min="getMin(request_index, index)"
                  step="0.01"
                  v-model="contract.contr_unit_price"
                  @change="autoCalculateContrTotal(request_index, index)"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :class="
                    'total_calculate metall-table-input selects_' +
                    request_index +
                    '_' +
                    index
                  "
                  type="number"
                  min="0"
                  step="0.01"
                  readonly
                  v-model="contract.contr_total"
                  @change="autoCalculateContrTotal(request_index, index)"
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  required
                  class="metall-table-input"
                  type="number"
                  min="0"
                  step="0.01"
                  v-model="contract.contr_count_gone"
                  @change="
                    autoCalculateContrTotal(request_index, index) ||
                      autoCalculateCountBalance(request_index, index) ||
                      autoCalculateAfterCount(request_index)
                  "
                />
              </td>
              <td class="metall-info-contract-cell">
                <input
                  :class="
                    'metall-table-input selects_' +
                    request_index +
                    '_' +
                    index +
                    ' ' +
                    isFirstTotal()
                  "
                  type="number"
                  min="0"
                  step="0.01"
                  v-model="contract.contr_count_balance"
                  :readonly="isFirst()"
                  @change="autoCalculateCountBalance(request_index, index)"
                />
              </td>
              <td
                class="metall-slot-hidden-notes"
                style="border-right: 1px solid #868686"
              >
                ...
              </td>
              <td class="metall-info-notes-cell">
                <input
                  required
                  :class="
                    'metall-table-input total_calculate ' + setColor(index)
                  "
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.count_after"
                  readonly
                  @change="
                    autoCalculateAfterCount(request_index) ||
                      autoCalculateAfterSum(request_index)
                  "
                />
              </td>
              <td class="metall-info-notes-cell">
                <input
                  required
                  :class="
                    'metall-table-input total_calculate ' + setColor(index)
                  "
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="isDisabled(index)"
                  v-model="request.total_after"
                  readonly
                  @change="autoCalculateAfterSum(request_index)"
                />
              </td>
              <td class="metall-info-notes-cell">
                <input
                  class="metall-table-input"
                  type="text"
                  v-model="contract.comment"
                />
              </td>
              <td style="border: none">
                <button
                  class="table-actions-button row-btn btn-red"
                  v-if="contract.first"
                  type="button"
                  @click="deleteContract(contract.id)"
                >
                  Удалить
                </button>
                <button
                  class="table-actions-button row-btn btn-blue"
                  v-if="!contract.finished"
                  type="button"
                  @click="stopContract(contract.id)"
                >
                  Расторгнуть
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <div class="table-sub-actions-block">
      <button
        type="button"
        class="table-actions-button btn-green"
        @click="openModal"
      >
        Добавить строку
      </button>
    </div>

    <!----------------------------------------------------------------------------------------- auth modal  -------------------------------------------------------------------------------------->
    <section class="auth-modal">
      <!-- Modal Content Wrapper -->
      <div id="auth-modal-content" class="auth-modal-content">
        <div class="modal-info">
          <div
            class="modal-info-inner"
            :class="{ modalInfoEcp: showModal === true }"
          >
            <div v-if="showModal">
              <!-- Requires proper solution -->
              <div class="modal-table-container">
                <h3 class="modal-h3">Добавление контракта / металла</h3>
                <form method="POST" @submit.prevent="createContract">
                  <table class="modal-table">
                    <thead>
                      <tr>
                        <th
                          class="
                            metall-info-sub-count metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Выберите вид металла
                        </th>
                        <th
                          class="
                            metall-info-sub-count metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Выберите категорию
                        </th>
                        <th
                          class="
                            metall-info-sub-count metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Общее кол-во по договору
                        </th>
                        <th
                          class="
                            metall-info-sub-realization
                            metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Способ реализации
                        </th>
                        <th
                          class="
                            metall-info-sub-payment metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Условия оплаты
                        </th>
                        <th
                          class="
                            metall-info-sub-naming metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Наименование покупателя
                        </th>
                        <th
                          class="metall-info-sub-bin metall-info-contract-cell"
                          scope="col"
                        >
                          БИН
                        </th>
                        <th
                          class="
                            metall-info-sub-contract-number
                            metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Номер договора
                        </th>
                        <th
                          class="metall-info-sub-date metall-info-contract-cell"
                          scope="col"
                        >
                          Дата договора
                        </th>
                        <th
                          class="
                            metall-info-sub-price metall-info-contract-cell
                            expanded
                          "
                          scope="col"
                        >
                          Цена за ед. тенге
                        </th>
                        <th
                          class="metall-info-sub-sum metall-info-contract-cell"
                          scope="col"
                        >
                          Сумма договора, тенге
                        </th>
                        <th
                          class="
                            metall-info-sub-exported metall-info-contract-cell
                          "
                          scope="col"
                        >
                          Вывезенное количество
                        </th>
                        <th
                          class="metall-info-sub-left metall-info-contract-cell"
                          scope="col"
                        >
                          Остаток по договору
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>
                          <select
                            @change="changeCatalog(newContract.type)"
                            v-model="newContract.type"
                            required
                          >
                            <option value="">Выберите вид металла</option>
                            <option value="black">Черный металл</option>
                            <option value="color">Цветной металл</option>
                          </select>
                        </th>
                        <th class="t-metall-sub-type" scope="rowgroup">
                          <select v-model="newContract.category" required>
                            <option value>Выберите категорию</option>
                            <option
                              v-for="catalog in listCatalogs"
                              :key="catalog.id"
                              :value="catalog.name_full"
                            >
                              {{ catalog.name }}
                            </option>
                          </select>
                        </th>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input"
                            type="number"
                            min="0"
                            step="0.01"
                            v-model="newContract.contr_count"
                            required
                            @change="
                              autoCalculateNewContrTotal() ||
                                autoCalculateCountNewBalance() ||
                                deleteRequiredSelectOneContract()
                            "
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <select
                            class="report-table-s selects_new_contract"
                            v-model="newContract.contr_method"
                            required
                          >
                            <option value="">Выберите значение</option>
                            <option value="Аукцион">Аукцион</option>
                            <option value="Товарная биржа">
                              Товарная биржа
                            </option>
                            <option value="Прямая адресная продажа">
                              Прямая адресная продажа
                            </option>
                          </select>
                        </td>
                        <td class="metall-info-contract-cell">
                          <select
                            class="'report-table-s selects_new_contract"
                            v-model="newContract.contr_conditions"
                            required
                          >
                            <option value="">Выберите значение</option>
                            <option value="100% предоплата">
                              100% предоплата
                            </option>
                            <option value="30% предоплата">
                              30% предоплата
                            </option>
                          </select>
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input selects_new_contract"
                            type="text"
                            v-model="newContract.contr_impl"
                            required
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input selects_new_contract"
                            type="text"
                            v-model="newContract.bin_company"
                            required
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input selects_new_contract"
                            type="text"
                            v-model="newContract.contr_number"
                            required
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input selects_new_contract"
                            type="date"
                            v-model="newContract.contr_date"
                            required
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input"
                            type="number"
                            min="0"
                            step="0.01"
                            v-model="newContract.contr_unit_price"
                            required
                            @change="autoCalculateNewContrTotal()"
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input total_calculate"
                            type="number"
                            v-model="newContract.contr_total"
                            disabled
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input"
                            type="number"
                            min="0"
                            step="0.01"
                            v-model="newContract.contr_count_gone"
                            required
                            @change="autoCalculateCountNewBalance()"
                          />
                        </td>
                        <td class="metall-info-contract-cell">
                          <input
                            class="metall-table-input total_calculate"
                            type="number"
                            v-model="newContract.contr_count_balance"
                            disabled
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    type="submit"
                    class="table-actions-button btn-green modal-btn"
                  >
                    Создать контракт
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <a href="#" class="close-auth-modal" @click="closeModal">
          <!-- X close auth icon -->
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0"
            y="0"
            viewBox="0 0 32 32"
            style="enable-background: new 0 0 32 32"
            xml:space="preserve"
            width="24"
            height="24"
          >
            <g id="icon-x-close">
              <path
                fill="#ffffff"
                d="M30.3448276,31.4576271 C29.9059965,31.4572473 29.4852797,31.2855701 29.1751724,30.980339 L0.485517241,2.77694915 C-0.122171278,2.13584324 -0.104240278,1.13679247 0.52607603,0.517159487 C1.15639234,-0.102473494 2.17266813,-0.120100579 2.82482759,0.477288136 L31.5144828,28.680678 C31.9872448,29.1460053 32.1285698,29.8453523 31.8726333,30.4529866 C31.6166968,31.0606209 31.0138299,31.4570487 30.3448276,31.4576271 Z"
                id="Shape"
              ></path>
              <path
                fill="#ffffff"
                d="M1.65517241,31.4576271 C0.986170142,31.4570487 0.383303157,31.0606209 0.127366673,30.4529866 C-0.12856981,29.8453523 0.0127551942,29.1460053 0.485517241,28.680678 L29.1751724,0.477288136 C29.8273319,-0.120100579 30.8436077,-0.102473494 31.473924,0.517159487 C32.1042403,1.13679247 32.1221713,2.13584324 31.5144828,2.77694915 L2.82482759,30.980339 C2.51472031,31.2855701 2.09400353,31.4572473 1.65517241,31.4576271 Z"
                id="Shape"
              ></path>
            </g>
          </svg>
        </a>
      </div>
      <div class="overlay" @click="closeModal"></div>
    </section>
  </div>
</template>

<script>
import { isApproved, isImpl, isRecipient, isSaveChange } from "@/variables";
import { mapGetters } from "vuex";

export default {
  name: "EditTableJustTwo",
  data() {
    return {
      reports: this.REPORT,
      initCategories: [],
      isApproved: false,
      isImpl: false,
      isRecipient: false,
      requests: [],
      old_balance: {},
      showModal: false,
      listCatalogs: [],
      blackCatalogs: [],
      colorCatalogs: [],
      newContract: {
        type: "",
        category: "",
        contr_method: "",
        contr_conditions: "",
        contr_total: "",
        contr_count_balance: "",
      },
    };
  },
  methods: {
    getBlackCatalog() {
      this.$store.dispatch("getBlackCatalog").then((response) => {
        this.blackCatalogs = response;
      });
    },
    getColorCatalog() {
      this.$store.dispatch("getColorCatalog").then((response) => {
        this.colorCatalogs = response;
      });
    },
    changeCatalog(value) {
      if (value === "black") {
        this.listCatalogs = this.blackCatalogs;
      } else if (value === "color") {
        this.listCatalogs = this.colorCatalogs;
      } else {
        this.listCatalogs = [];
      }
    },
    isFirstTotal() {
      if (this.REPORT.first) {
        return "";
      }
      return "total_calculate";
    },
    isFirst() {
      if (this.REPORT.first) {
        return false;
      }
      return true;
    },
    getInitCategories() {
      this.$store
        .dispatch("getInitCategories", this.$route.params.id)
        .then((response) => {
          this.initCategories = response.init_categories;
        });
    },
    getReport() {
      this.$store
        .dispatch("getReport", this.$route.params.id)
        .then((response) => {
          this.requests = response.requests;
          for (let i = 0; i < this.requests.length; ++i) {
            let contracts = this.requests[i].contracts;
            this.old_balance[i] = {};
            for (let j = 0; j < contracts.length; ++j) {
              this.old_balance[i][j] =
                parseFloat(contracts[j].contr_count_balance) +
                parseFloat(contracts[j].contr_count_gone);
            }
          }
        });
    },
    updateReport() {
      let formData = {
        requests: this.requests,
        report_id: this.$route.params.id,
        is_save_change: isSaveChange(this.REPORT.status),
      };
      this.$store.dispatch("updateReport", formData);
    },
    getMin(request_index, index) {
      if (this.requests[request_index].contracts[index].contr_count == "0") {
        return 0;
      }
      return 0.01;
    },
    change_contr_count(request_index, index) {
      this.old_balance[request_index][index] =
        this.requests[request_index].contracts[index].contr_count;
    },

    autoCalculateContrTotal(request_index, index) {
      this.requests[request_index].contracts[index].contr_total = (
        parseFloat(this.requests[request_index].contracts[index].contr_count) *
        parseFloat(
          this.requests[request_index].contracts[index].contr_unit_price
        )
      ).toFixed(2);
    },

    autoCalculateCountBalance(request_index, index) {
      if (this.REPORT.first === false) {
        this.requests[request_index].contracts[index].contr_count_balance = (
          parseFloat(this.old_balance[request_index][index]) -
          parseFloat(
            this.requests[request_index].contracts[index].contr_count_gone
          )
        ).toFixed(2);
      }
    },
    autoCalculateAfterCount(request_index) {
      let contracts = this.requests[request_index].contracts;
      let gone_sum = 0.0;
      for (let i = 0; i < contracts.length; ++i) {
        gone_sum += parseFloat(contracts[i].contr_count_gone);
      }
      this.requests[request_index].count_after = (
        parseFloat(this.requests[request_index].count_before) +
        parseFloat(this.requests[request_index].count_come) -
        parseFloat(this.requests[request_index].for_own_needs) -
        parseFloat(this.requests[request_index].for_social_commitment) -
        parseFloat(gone_sum)
      ).toFixed(2);
      this.autoCalculateAfterSum(request_index);
    },
    autoCalculateAfterSum(request_index) {
      this.requests[request_index].total_after = (
        parseFloat(this.requests[request_index].count_after) *
        parseFloat(this.requests[request_index].price_before)
      ).toFixed(2);
    },
    autoCalculateBeforeSum(request_index) {
      this.requests[request_index].total_before = (
        parseFloat(this.requests[request_index].count_before) *
        parseFloat(this.requests[request_index].price_before)
      ).toFixed(2);
    },
    setColor(index) {
      if (index) {
        return "duplicate";
      }
      return "";
    },

    isDisabled(index) {
      if (index) {
        return true;
      }

      return false;
    },
    isDisabledForMain(index, request_index) {
      if (
        this.initCategories.includes(this.requests[request_index].category_full)
      ) {
        return true;
      }

      return false;
    },

    hideRemnantColumns() {
      let metallLeft = document.querySelectorAll(".metall-left-in-stock-botm"),
        metallSubColumns = document.querySelectorAll(
          ".metall-left-in-stock-sub-botm"
        ),
        metallReceived = document.querySelector(".metall-received"),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHidden = document.querySelectorAll(".metall-slot-hidden"),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallLeft.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallReceived.classList.toggle("table-column-hide");
      metallReceivedCount.classList.toggle("table-column-hide");

      metallSubColumns.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHide.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHidden.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    deleteRequiredSelectOneContract() {
      var all_select = document.getElementsByClassName("selects_new_contract");
      if (this.newContract.contr_count == 0) {
        Array.prototype.forEach.call(all_select, function (el) {
          el.removeAttribute("required", "required");
          el.setAttribute("disabled", "disabled");
        });
        this.newContract.contr_unit_price = 0;
        this.newContract.contr_total = 0;
        this.newContract.contr_count_gone = 0;
        this.newContract.contr_count_balance = 0;
      } else {
        Array.prototype.forEach.call(all_select, function (el) {
          el.setAttribute("required", "required");
          el.removeAttribute("disabled", "disabled");
        });
      }
    },
    deleteRequiredSelect(request_index, index) {
      var all_select = document.getElementsByClassName(
        "selects_" + request_index + "_" + index
      );
      if (this.requests[request_index].contracts[index].contr_count == 0) {
        Array.prototype.forEach.call(all_select, function (el) {
          el.removeAttribute("required", "required");
        });
        this.requests[request_index].contracts[index].contr_unit_price = 0;
        this.requests[request_index].contracts[index].contr_total = 0;
        this.requests[request_index].contracts[index].contr_count_gone = 0;
        this.requests[request_index].contracts[index].contr_count_balance = 0;
      } else {
        Array.prototype.forEach.call(all_select, function (el) {
          el.setAttribute("required", "required");
        });
      }
    },
    checkRequired() {
      var selects = document.getElementsByClassName("contr_count");
      // for (let i = 0; i < selects.length; ++i){
      //   let index = selects[i].id;
      //   let select_contr_method = document.getElementById('select_contr_method_' + el.id)
      // }

      Array.prototype.forEach.call(selects, function (el) {
        if (el.value == 0) {
          let index = el.id;
          let select_contr_method = document.getElementById(
            "edit_select_contr_method_" + index
          );
          select_contr_method.removeAttribute("required");
          let select_contr_conditions = document.getElementById(
            "edit_select_contr_conditions_" + index
          );
          select_contr_conditions.removeAttribute("required");
          let contr_date = document.getElementById("edit_contr_date_" + index);
          contr_date.removeAttribute("required");

          let edit_contr_impl = document.getElementById(
            "edit_contr_impl_" + index
          );
          edit_contr_impl.removeAttribute("required");

          let edit_bin_company = document.getElementById(
            "edit_bin_company_" + index
          );
          edit_bin_company.removeAttribute("required");

          let edit_contr_number = document.getElementById(
            "edit_contr_number_" + index
          );
          edit_contr_number.removeAttribute("required");
        }
      });
    },
    showRemnantColumns() {
      let metallLeft = document.querySelectorAll(".metall-left-in-stock-botm"),
        metallSubColumns = document.querySelectorAll(
          ".metall-left-in-stock-sub-botm"
        ),
        metallReceived = document.querySelector(".metall-received"),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHidden = document.querySelectorAll(".metall-slot-hidden"),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallLeft.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallReceived.classList.toggle("table-column-hide");
      metallReceivedCount.classList.toggle("table-column-hide");

      metallSubColumns.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHide.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHidden.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    hideContractColumns() {
      let metallInformation = document.querySelector(".metall-information"),
        metallInfoContractCell = document.querySelectorAll(
          ".metall-info-contract-cell"
        ),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHiddenContract = document.querySelectorAll(
          ".metall-slot-hidden-contract"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoContractCell.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenContract.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    showContractColumns() {
      let metallInformation = document.querySelector(".metall-information"),
        metallInfoContractCell = document.querySelectorAll(
          ".metall-info-contract-cell"
        ),
        metallReceivedCount = document.querySelector(".metall-received"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHiddenContract = document.querySelectorAll(
          ".metall-slot-hidden-contract"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoContractCell.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHiddenContract.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    hideNotesColumns() {
      let metallInformation = document.querySelector(".metall-notes"),
        metallInfoNotesCells = document.querySelectorAll(
          ".metall-info-notes-cell"
        ),
        metallTdHiddenNotes = document.querySelectorAll(
          ".metall-slot-hidden-notes"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoNotesCells.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenNotes.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    showNotesColumns() {
      let metallInformation = document.querySelector(".metall-notes"),
        metallInfoNotesCells = document.querySelectorAll(
          ".metall-info-notes-cell"
        ),
        metallTdHiddenNotes = document.querySelectorAll(
          ".metall-slot-hidden-notes"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoNotesCells.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenNotes.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    appendSpaceAtFly() {
      let binEditInputs = document.querySelectorAll(".bin-input-edit");
      binEditInputs.forEach((item) => {
        item.addEventListener("input", function (e) {
          let target = e.target,
            position = target.selectionEnd,
            length = target.value.length;

          target.value = target.value
            .replace(/\s/g, "")
            .replace(/(\d{4})/g, "$1 ")
            .trim();
          target.selectionEnd = position +=
            target.value.charAt(position - 1) === " " &&
            target.value.charAt(length - 1) === " " &&
            length !== target.value.length
              ? 1
              : 0;
        });
      });
    },
    openModal() {
      this.showModal = true;

      let body = document.body;
      body.classList.add("show-auth-modal", "noscroll");

      // Close modal if ESC key tapped
      body.addEventListener("keyup", (e) => {
        if (e.keyCode == 27) {
          this.closeModal();
        }
      });
    },
    closeModal() {
      this.showModal = false;
      this.showModalEcp = false;
      this.showModalEcpList = false;
      this.showModalHistory = false;
      this.showModalApprovedPersons = false;
      this.showModalEditApprovedReport = false;
      this.showModalEditRequest = false;
      let body = document.body;
      body.classList.remove("show-auth-modal", "noscroll");
    },
    createContract() {
      const formData = {
        new_contract: this.newContract,
        report_id: this.$route.params.id,
      };
      this.$store.dispatch("createNewContract", formData);
    },
    deleteContract(contractId) {
      this.$store.dispatch("deleteContract", contractId);
    },
    stopContract(contractId) {
      this.$store.dispatch("stopContract", contractId);
    },
    autoCalculateNewContrTotal() {
      this.newContract.contr_total = (
        this.newContract.contr_count * this.newContract.contr_unit_price
      ).toFixed(2);
    },
    autoCalculateCountNewBalance() {
      this.newContract.contr_count_balance = (
        this.newContract.contr_count - this.newContract.contr_count_gone
      ).toFixed(2);
    },
  },
  mounted() {
    this.getReport();
    this.getInitCategories();
    this.isApproved = isApproved(this.USER.ouser);
    this.isImpl = isImpl(this.USER.ouser);
    this.isRecipient = isRecipient(this.USER.ouser);
    this.appendSpaceAtFly();
    this.getBlackCatalog();
    this.getColorCatalog();

    // document.querySelectorAll('.bin-input-edit').addEventListener('input', function (e) {
    //   let target = e.target, position = target.selectionEnd, length = target.value.length;
    //
    //   target.value = target.value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
    //   target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
    // });
  },
  updated() {
    this.checkRequired();
  },
  computed: {
    ...mapGetters(["REPORT", "USER"]),
  },
};
</script>

<style scoped>
.duplicate {
  background: #717171 !important;
  color: #fff;
}

.modal-table {
  max-width: 1000px;
}

@media (max-width: 2000px) {
  .modal-table-container {
    max-width: 1000px;
    overflow-x: auto;
  }
}

.modal-btn {
  margin-top: 50px;
}

.modal-h3 {
  margin-bottom: 50px !important;
}

.table-container {
  overflow-x: auto;
  padding: 0 2rem;
  /* max-width: 1800px; */
  margin: 0 auto;
}

.table-container-inner {
  padding: 0.5rem;
  /* padding: 1rem 2rem;
  margin-right: 2rem; */
  margin: 0 2rem;
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

.table-title {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-bottom: 1px solid black;
}

th,
td {
  border: 1px solid #868686;
  height: 30px;
  padding: 0 1rem;
}

select {
  height: 100%;
  border: none;
  background-color: white;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.tr-fixed-height {
  height: 100px;
}

.t-metall-type {
  height: 296px;
  width: 120px;
}

.t-metall-sub-type {
  width: 130px;
  height: 60px;
}

.metall-left-in-stock-botm,
.metall-left-in-stock-eotm {
  /* width: 180px; */
  height: 75px;
}

.metall-left-in-stock-sub-botm,
.metall-left-in-stock-sub-eotm {
  /* width: 90px; */
  height: 50px;
}

.metall-received {
  position: relative;
  width: 120px;
}

.metall-information,
.metall-notes {
  position: relative;
}

.table-column-hide {
  /* opacity: 0; */
  /* visibility: hidden; */
  /* appearance: none; */
  display: none;
  /* visibility: collapse; */
}

.table-column-show {
  opacity: 1;
}

.hide-btn,
.show-btn {
  position: absolute;
  top: 0;
  right: 12px;
  padding: 0.5rem;
  background: none;
  border: none;
}

.hide-btn:focus,
.show-btn:focus {
  outline: none;
}

.hide-btn i::before,
.show-btn i::before {
  font-size: 1.2rem;
}

.metall-info-sub-count {
  width: 120px;
}

.metall-info-sub-realization {
  width: 120px;
}

.metall-info-sub-payment {
  width: 90px;
}

.metall-info-sub-naming {
  width: 120px;
}

.metall-info-sub-bin {
  /* width: 120px !important; */
  padding: 0 3rem;
}

.metall-info-sub-contract-number {
  width: 120px;
}

.metall-info-sub-date {
  width: 110px;
}

.metall-info-sub-price {
  width: 140px;
}

.metall-info-sub-sum {
  width: 140px;
}

.metall-info-sub-exported {
  width: 140px;
}

.metall-info-sub-left {
  width: 140px;
}

/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
  position: relative;
  /* width: 100px; */
  /* height: 75px; */
  display: none;
  border: none;
  /* border-bottom: 1px solid #868686; */
  margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
  line-height: 75px;
}

.metall-slot-hidden-notes {
  border-right: 1px solid black;
}

.metall-table-input {
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}

input:focus {
  border: none;
  outline: none;
  height: 70px;
}

.categories-top-actions {
  margin: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.table-actions-button.row-btn {
  padding: 0.5rem 1rem;
}

.table-sub-actions-block {
  padding: 1rem;
  margin-right: 2rem;
  display: flex;
  justify-content: flex-end;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.total_calculate {
  background: rgba(89, 36, 36, 0.27);
}

.report-table-s {
  height: 100%;
  border: none;
  font-size: 0.8rem;
  background: none;
}

/* auth Modal
-----------------------------------------*/
.auth-modal,
.auth-modal .overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
}

.auth-modal {
  overflow: hidden;
  position: fixed;
  opacity: 0;

  -webkit-transform: translate(500%, 0%);
  transform: translate(500%, 0%);

  -webkit-transition: -webkit-transform 0s linear 0s;
  transition: transform 0s linear 0s;

  /* using flexbox for vertical centering */

  /* Flexbox display */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;

  /* Vertical alignment */
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.auth-modal .overlay {
  z-index: 0;
  background: rgba(13, 1, 61, 0.82);
  /* overlay color */

  opacity: 0;

  -webkit-transition: opacity 0.2s ease-out 0.05s;
  transition: opacity 0.2s ease-out 0.05s;
}

.auth-modal-content {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;

  margin: 0 auto;

  overflow-y: visible;

  background: #000;

  width: calc(100% - 12em);
  height: 0;
  padding-top: calc((100% - 12em) * 0.5625);
  /* 16:9 calc */
}

/* Scaling to fit within the current Viewport size:
   When viewport aspect ratio is greater than 16:9
   work off the height instead of the width for calc */
@media (min-aspect-ratio: 16/9) {
  .auth-modal-content {
    width: 0;
    height: calc(100vh - 10em);
    padding-top: 0;
    padding-left: calc((100vh - 10em) * 1.7778);
    /* 16:9 calc */
  }
}

/* Mobile Layout Tweaks - side margins reduced */
@media (max-width: 640px) {
  .auth-modal-content {
    width: calc(100% - 1em);
    padding-top: calc((100% - 1em) * 0.5625);
    /* 16:9 calc */
  }
}

.close-auth-modal {
  display: block;
  position: absolute;
  left: 0;
  top: -40px;

  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.modal-info {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;

  /* background: #000; */
  /* box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.5); */
}

.modal-info-inner {
  overflow: scroll;
  background: white;
  padding: 4rem 5rem;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 2px 16px rgba(235, 235, 235, 1);
}

.modalInfoEcp {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-info-inner h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.auth-moda-explanations {
  margin: 0 0 1rem 0;
}

.auth-choose-cert {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  background: #36429e;
  color: white;
  cursor: pointer;
}

/* Show modal by adding class to body */
.show-auth-modal .auth-modal {
  opacity: 1;

  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}

.show-auth-modal .auth-modal .overlay {
  opacity: 1;
}

.show-auth-modal .auth-modal-content {
  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}
</style>